import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { minDate, requiredDate, requiredDates } from "../../../../helpers/forms/validate.js";
import { generateViewsComponent } from "../../../../helpers/views.js";
import useInput from "../../../../hooks/forms/useInput/index.js";
import CalendarDesktop from "./views/desktop/index.js";
import CalendarMobile from "./views/mobile/index.js";
export const Calendar = generateViewsComponent(CalendarDesktop, CalendarMobile);
export const FormCalendar = (props)=>{
    const { isHiddenRequired: _isHiddenRequired , ...rest } = props;
    const finalValidate = useMemo(()=>{
        let validate = [];
        if (props.validate) {
            if (Array.isArray(props.validate)) {
                validate = [
                    ...props.validate
                ];
            } else {
                validate = [
                    props.validate
                ];
            }
        }
        if (props.mode === 'single') validate.push(requiredDate());
        if (props.mode === 'range') validate.push(requiredDates());
        if (props.minDate) validate.push(minDate(props.minDate));
        return validate;
    }, [
        props.minDate,
        props.mode,
        props.validate
    ]);
    const { field , error , hasError  } = useInput({
        ...props,
        validate: finalValidate
    });
    return /*#__PURE__*/ _jsx(Calendar, {
        ...rest,
        ...field,
        error: error,
        hasError: hasError,
        label: props.label
    });
};
export default Calendar; /*
	EXAMPLES:
		onChange:
			const handleOnChange = (dates: Date[], currentDateString: string, flatPickrInstance: any, data?: any) => {
				console.log(
					`HANDLE: onChange: dates:${dates}, currentDateString:${currentDateString}, self:${flatPickrInstance}, data:${data}`
				);
			};
		HTML:
			RANGE:
				<Calendar
					label={'Fechas de tu viaje'}
					mode={'range'}
					minDate={new Date()}
					showMonths={2}
					locale={'es'}
					enableTime={false}
					monthSelectorType={'static'}
					value={[addDays(new Date(), 5), addDays(new Date(), 10)]}
					onChange={handleOnChange}
					disabled={false}
					events={
						[
							{
								legend: {
									text: 'Días con vuelo directo',
									class: 'flatpickr-day-footer-literal',
								},
								date: {
									class: 'flatpickr-day--direct-flight',
									dates: [
										new Date('Tue Oct 11 2022 23:00:00 GMT+0100 (Central European Standard Time)'),
										new Date('Tue Oct 12 2022 23:00:00 GMT+0100 (Central European Standard Time)'),
									],
								},
							},
						]
					}
				></Calendar>

			SINGLE:
				<Calendar
					label={'Fechas de tu viaje'}
					enableTime={false}
					onChange={handleOnChange}
					disabledDates={[addDays(new Date(), 5), addDays(new Date(), 4)]}
					dateFormat={'D, j M Y H:i'}
					events={[
						{
							legend: {
								text: 'Precio chollo',
								class: 'flatpickr-day-footer-bargain-price',
							},
							date: {
								class: 'flatpickr-day--bargain-price',
								dates: [
									new Date('Tue Oct 18 2022 23:00:00 GMT+0100 (Central European Standard Time)'),
									new Date('Tue Oct 20 2022 23:00:00 GMT+0100 (Central European Standard Time)'),
								],
							},
						},
					]}
				></Calendar>
*/ 

//# sourceMappingURL=index.js.map